<div class="chip-button-tabs" [ngClass]="{'d-none': loading, 'd-block': !loading}">
    <mat-chip-listbox [value]="selected" [hideSingleSelectionIndicator]="true">
        <mat-chip-option *ngFor="let option of chipOptions" [disableRipple]="true" [value]="option.value" [attr.data-sb-qa]="option.qaTag" (selectionChange)="SelectionChange($event)" [selectable]="selected != option.value">
            <div class="d-flex align-items-center" [ngClass]="{'gap-1': option.hasIcon || selected == option.value}">
                <div *ngIf="option.hasIcon && selected != option.value" class="scss-chip-tab-fade-in">
                    <ng-container *ngTemplateOutlet="option.prefixIcon"></ng-container>
                </div>
                <div *ngIf="!option.hasIcon && selected != option.value" class="scss-chip-tab-animation"></div>
                <lib-icon *ngIf="selected == option.value" [ngClass]="{'scss-chip-tab-animation-slide-out': !option.hasIcon, 'scss-chip-tab-fade-in': option.hasIcon}" [icon]="Icon.Common.Check"
                    [size]="IconSize.ExtraSmall" [qaTag]="option.qaTag + '-selected-icon'"></lib-icon>
                <div class="px-1"><ng-container *ngTemplateOutlet="option.content"></ng-container></div>
            </div>
        </mat-chip-option>
    </mat-chip-listbox>
</div>
